import { Link } from "react-router-dom";

export default function AdminSettingsPage() {
  return (
    <div data-testid="admin-settings">
      <h1 className="font-serif text-4xl text-cc-text mb-2">Ayarlar</h1>
      <p className="text-sm text-cc-muted mb-8">Sistem ayarları</p>

      <div className="bg-white border border-admin-border p-6 mb-6">
        <h3 className="font-medium text-cc-text mb-3">Kısayollar</h3>
        <ul className="space-y-2 text-sm">
          <li>• <Link to="/admin/seo" className="text-cc-sepia hover:underline">SEO Ayarları</Link></li>
          <li>• <Link to="/admin/menus" className="text-cc-sepia hover:underline">Menü Düzenleyici</Link></li>
          <li>• <Link to="/admin/redirects" className="text-cc-sepia hover:underline">Yönlendirmeler</Link></li>
          <li>• <Link to="/admin/users" className="text-cc-sepia hover:underline">Kullanıcılar & Roller</Link></li>
        </ul>
      </div>

      <div className="bg-white border border-admin-border p-6">
        <h3 className="font-medium text-cc-text mb-3">Sistem</h3>
        <div className="text-sm space-y-2 text-cc-muted">
          <div>Platform: Capella Cave v1.0 — Phase 1 (Cappadocia Journal)</div>
          <div>Hedef açılış: 2028 (Phase 2 — Hotel)</div>
          <div>API: <a className="text-cc-sepia" href="/api/seo/sitemap.xml" target="_blank" rel="noreferrer">sitemap.xml</a> · <a className="text-cc-sepia" href="/api/seo/robots.txt" target="_blank" rel="noreferrer">robots.txt</a></div>
        </div>
      </div>
    </div>
  );
}
